import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-agenda-cobrador',
  templateUrl: './agenda-cobrador.component.html',
  styleUrls: ['./agenda-cobrador.component.scss']
})
export class AgendaCobradorComponent implements OnInit, AfterViewInit, OnDestroy {

  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();
  newForm: FormGroup;

  constructor
  (
    private _cartera: CarteraService
  ) 
  { 
    this.dtTrigger.next();
    this.newForm = this.createForm();
  }

  ngOnInit() {
    this.dtOptions = {
      order: [1, 'asc'],
      responsive: true,
      autoWidth: false,
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          orderable: false,
          targets: 0
        },
        {
          title: 'Fecha',
          data: 'fecha'
        },
        {
          title: 'Jornada',
          data: 'jornada'
        },
        {
          title: 'Hora',
          data: 'hora'
        },
        {
          title: 'Empresa',
          data: 'empresa'
        },
        {
          title: 'Nombre',
          data: 'nombre_grupo'
        },
        {
          title: 'Radicado',
          data: 'radicado'
        },
        {
          title: 'Cobrador',
          data: 'cobrador'
        },
        {
          title: 'Actividad',
          data: 'actividad'
        },
        {
          title: 'N°Factura',
          data: 'n_factura'
        },
        {
          title: 'Valor',
          data: 'valor_cobro'
        },
        {
          title: 'Mes',
          data: 'mes_factura'
        },
        {
          title: 'Notas',
          data: 'notas',
          class: 'none'
        },
        {
          title: 'Teléfonos',
          data: 'telefonos'
        },
        {
          title: 'Dirección Cobro',
          data: 'direccion_cob',
          class: 'none'
        },
        {
          title: 'Dirección Alternativa',
          data: 'direccion_alt',
          class: 'none'
        },
        {
          title: 'Reprogramación',
          data: 'reprogramacion'
        }
      ],
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'excel',
          title: function () { return `Cobros Agendados Entre ${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')} Y ${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`},
          text: 'Excel',
          filename: function () { return `cobros_${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')}_${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`}
        },
        { 
          extend: 'pdf',
          text: 'PDF',
          orientation: 'landscape',
          pageSize: 'A2',
          filename: function () { return `cobros_${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')}_${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`},
          title: function () { return `Cobros Agendados Entre ${moment($('#fecha_inicial').val()).format('DD-MM-YYYY')} Y ${moment($('#fecha_final').val()).format('DD-MM-YYYY')}`}
        }
      ]
    }
  }

  createForm(): FormGroup{
    return new FormGroup({
      fecha_inicio: new FormControl(moment()),
      fecha_final: new FormControl(moment())
    });
  }

  public agendaCobros(form: any){
    const Fecha_Inicio: string = moment(form['fecha_inicio']).format('YYYY-MM-DD');
    const Fecha_Final: string = moment(form['fecha_final']).format('YYYY-MM-DD');
    const Usuario: number = JSON.parse(localStorage.getItem('usuario'))['id_usuario'];

    this._cartera.verCobrosCartera(Fecha_Inicio, Fecha_Final, 0, Usuario, undefined, undefined).subscribe((data: any) => {
      this.renderer();
      this.tableOpt = data;
    });
  }

  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

}
